export function generateStrapiRelatedBlogsParams(sku: string | string[]) {
  return {
    populate: {
      cms_category: {
        fields: ["name"],
      },
      image: {
        fields: ["*"],
      },
    },
    filters: {
      relatedProductsSkus: {
        $containsi: sku,
      },
    },
  };
}
